import React from 'react';
import * as LucideIcons from 'lucide-react';

const TrustBadges = () => {
  const badges = [
    {
      icon: LucideIcons.Award,
      title: '5-Star Rated',
      description: 'Excellent reviews on Google & MyBuilder'
    },
    {
      icon: LucideIcons.Shield,
      title: 'Fully Insured',
      description: 'Public & Employer\'s Liability'
    },
    {
      icon: LucideIcons.Clock,
      title: 'On-Time Delivery',
      description: 'Projects completed on schedule'
    },
    {
      icon: LucideIcons.BadgeCheck,
      title: 'Quality Guaranteed',
      description: 'Up to 2-year workmanship warranty'
    },
    {
      icon: LucideIcons.FileCheck,
      title: 'Free Quotes',
      description: 'No-obligation estimates'
    },
    {
      icon: LucideIcons.Users,
      title: 'Family Business',
      description: 'Personal service & attention to detail'
    },
    {
      icon: LucideIcons.ThumbsUp,
      title: 'Trusted Locally',
      description: 'Serving Suffolk, Essex & London'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Why Choose T&M Construction?</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Trusted by homeowners across Suffolk, Essex, and London for quality construction and renovation services
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {badges.map((badge) => (
            <div 
              key={badge.title} 
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow text-center group"
            >
              <div className="w-14 h-14 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-orange-600 transition-colors">
                <badge.icon className="w-7 h-7 text-orange-600 group-hover:text-white transition-colors" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1">{badge.title}</h3>
              <p className="text-xs text-gray-500">{badge.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
